export const step6 = {
  get isNextBtnActive() {
    return this.userInput.companyName.kr !== '';
  },

  skip() {
    this.userInput.companyName.kr = '미정';

    this.moveNext();
  },
};
